import styled from 'styled-components'

import { Container as Card } from '../../../../components/Card/styles'

export const Container = styled.article`
	min-height: 82vh;

	main {
		padding: 35px 100px;

		@media(max-width: 1000px) {
			padding: 20px 16px;
		}

		@media(max-width: 1000px) {
			padding: 10px 0;
		}
	}
`
